import React from 'react';
import '../styles/About.css';

const About = ({ onClose }) => {
    return (
        <div className="about-overlay" onClick={onClose}>
            <div className="about-container" onClick={(e) => e.stopPropagation()}>
                <button className="about-close" onClick={onClose}>✕</button>
                
                <div className="about-content">
                    <h1>About CLIP AND GO</h1>
                    
                    <h2>What is CLIP AND GO?</h2>
                    <p>
                        CLIP AND GO is a lightweight, fast, and secure web application designed to simplify text sharing across your devices. Whether you're working on multiple computers, tablets, or phones, CLIP AND GO makes it effortless to copy text from one device and paste it on another.
                    </p>

                    <h2>Key Features</h2>
                    <ul>
                        <li><strong>Instant Text Sync</strong> - Copy text on one device and instantly access it on another using a unique Page URL</li>
                        <li><strong>QR Code Sharing</strong> - Generate QR codes for quick access from mobile devices without typing long URLs</li>
                        <li><strong>History Tracking</strong> - Keep a complete history of all items you've saved, making it easy to find and reuse text</li>
                        <li><strong>Secure & Private</strong> - All your clipboard data is stored securely with encrypted connections</li>
                        <li><strong>No Installation Required</strong> - Just open the app in any web browser and start sharing</li>
                    </ul>

                    <h2>How It Works</h2>
                    <ol>
                        <li>Open CLIP AND GO on any device</li>
                        <li>A unique Page ID is automatically generated for you</li>
                        <li>Share the URL or scan the QR code on your other devices</li>
                        <li>Copy text on one device and it appears instantly on all connected devices</li>
                        <li>Access your full saved history anytime</li>
                    </ol>

                </div>
            </div>
        </div>
    );
};

export default About;
